/*============================================================================
  bundle-quickview-init.js
  ---------------------------------------------------------------------------
  Runs the "Complete Your Set" bundle inside the product Quick View.

  Why this exists:
  The bundle (snippets/product-bundle.liquid) ships its own inline <script>
  that builds the option galleries, paints the colour swatches, wires the
  colour/size pickers and enables the CTA. On a normal PDP that script is
  server-rendered and runs fine. But Quick View loads the product's blocks by
  parsing fetched HTML (DOMParser) and appending it — and the HTML spec says a
  <script> inserted that way is INERT (never executes). So in Quick View the
  bundle rendered blank images, grey swatches, no colour/size sync and a CTA
  stuck disabled.

  Fix: when Quick View finishes injecting the product blocks
  (theme.js dispatches `quickview:loaded`), find any not-yet-initialised
  .bundle and re-execute its behaviour <script> by cloning it into a fresh
  <script> node — inserting a freshly created script DOES execute it. The
  bundle's own guard (el.dataset.ready) keeps this a no-op everywhere it has
  already run, so this only ever fires for a Quick-View-injected bundle.

  Works for every bundle family (leggings/bra, sweatshirt/sweatpants, …)
  because it is keyed on the generic `.bundle` element, not any one product.
==============================================================================*/
(function () {
  'use strict';

  function isJsScript(node) {
    if (!node || node.tagName !== 'SCRIPT') { return false; }
    var t = (node.getAttribute('type') || '').toLowerCase();
    // Classic JS only — skip the bundle's data-* JSON payloads and modules.
    return t === '' || t === 'text/javascript' || t === 'application/javascript';
  }

  function runBundleScripts(root) {
    var bundles = (root || document).querySelectorAll('.bundle');
    for (var i = 0; i < bundles.length; i++) {
      var bundle = bundles[i];
      // Already initialised (normal PDP, or a previous run) — nothing to do.
      if (bundle.dataset.ready) { continue; }
      // The behaviour script is the .bundle's next element sibling.
      var script = bundle.nextElementSibling;
      if (!isJsScript(script) || script.dataset.ran) { continue; }
      script.dataset.ran = '1';
      var fresh = document.createElement('script');
      // Keep it in place so document.currentScript.previousElementSibling
      // resolves back to this .bundle when the code runs.
      fresh.textContent = script.textContent;
      script.parentNode.replaceChild(fresh, script);
    }
  }

  document.addEventListener('quickview:loaded', function (e) {
    // Let the just-appended DOM settle one frame before executing.
    requestAnimationFrame(function () {
      var pid = e && e.detail && e.detail.productId;
      var modal = pid ? document.getElementById('QuickShopModal-' + pid) : null;
      runBundleScripts(modal || document);
    });
  });
})();
